import { render } from "./Cookies.vue?vue&type=template&id=6996727f&scoped=true&ts=true"
import script from "./Cookies.vue?vue&type=script&lang=ts"
export * from "./Cookies.vue?vue&type=script&lang=ts"

import "./Cookies.vue?vue&type=style&index=0&id=6996727f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6996727f"]])

export default __exports__